import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { OrdersEdge } from '@shared/generated'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'
import { formatDate } from '@shared/uttils/formatDate'
import { getOrderStatusLabel } from '@shared/uttils/order'

import styles from './styles.module.scss'

export default function OrderHeader ({
  data,
  isDetail,
  handleDetailClick,
}: {
  data: NonNullable<NonNullable<OrdersEdge['edges']>[number]>;
  isDetail: boolean;
  handleDetailClick: () => void;
}) {
  const { t: to } = useTranslation('order')
  const { label, color } = getOrderStatusLabel(data.status, to)
  return (
    <div
      className={classNames(styles.header, {
        [styles['header--active']]: isDetail,
      })}
    >
      <div className={styles.header__order}>
        <div className={styles.header__title}>
          <h4>
            {to('order')} <span data-green>№ {data.id}</span>
          </h4>
          <span> {formatDate(data?.created_at)}</span>
        </div>
        <div className={styles.header__control}>
          {!isDetail && <h3> {formatPrice(data.total as number)}</h3>}
          <span data-color={color} className={styles.header__status}>
            {label}
          </span>
        </div>
        <Button
          onClick={handleDetailClick}
          className={classNames(styles.header__button, {
            [styles['header__button--active']]: isDetail,
          })}
          theme="grey"
          size="small"
        >
          <ReactSVG src="/icons/arrow-right.svg" wrapper="span" />
        </Button>
      </div>

      {isDetail && (
        <>
          <div className={styles.header__data}>
            {data.recipientInfo?.firstName && (
              <InfoRow
                label={to('order.user')}
                value={data.recipientInfo?.firstName as string}
              />
            )}

            <InfoRow
              label={to('order.address')}
              value={data.address as string}
            />
            <InfoRow
              label={to('order.time-delivery')}
              value={data.deliverySlot?.slotTime || ''}
              isHighlight
            />
            {data.paymentMethod && (
              <InfoRow
                label={to('order.payment-variant')}
                value={`${to('card')} ****  ${data.paymentMethod?.last || ''}`}
                isHighlight
              />
            )}
          </div>
          {/* <div className={styles.header__addition}>
            <p
              dangerouslySetInnerHTML={{
                __html: to("order.add-delivery") + " 7:53",
              }}
            ></p>
            <Button size="medium"> {to("order.button.catalog")}</Button>
          </div> */}
        </>
      )}
    </div>
  )
}

function InfoRow ({
  label,
  value,
  isHighlight = false,
}: {
  label: string;
  value: string;
  isHighlight?: boolean;
}) {
  return (
    <p>
      {label}: <span data-green={isHighlight ? true : undefined}>{value}</span>
    </p>
  )
}
